module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"selected":"Выбрано","andMore":"и еще"}}')
  delete Component.options._Ctor
}
